const breadcrumbDictionary = (item: string) => {
  switch (item) {
    case "passenger":
      return "مسافر";
    case "panel":
      return "پنل کاربری";
    case "administrator":
      return "مدیر سیستم";
    case "municipality":
      return "شهرداری";
    case "drivers":
      return "راننده ها";
    case "company":
      return "شرکت";
    case "municipality":
      return "شهرداری";
    case "orders":
      return "سفارش ها";
    case "clients":
      return "مشتری ها";
    case "categories":
      return "دسته بندی ها";
    case "update-price":
      return "ویرایش قیمت";
    case "work-time":
      return "ساعت کاری";
    case "area":
      return "مناطق";
    case "ticket":
      return "تیکت";
    default:
      break;
  }
};
export default breadcrumbDictionary;
